import React from 'react';

const TechStack = () => {
  return (
    <section className="tech-stack" id="tech">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Công nghệ sử dụng</h2>
          <p className="section-description">
            Hardware và software thực tế được sử dụng trong dự án simHUD
          </p>
        </div>
        <div className="tech-grid">
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">developer_board</span>
            </div>
            <h3>ESP32-S3</h3>
            <p>Vi điều khiển chính cho dự án</p>
          </div>
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">tv</span>
            </div>
            <h3>LCD Display</h3>
            <p>Màn hình hiển thị thông tin</p>
          </div>
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">code</span>
            </div>
            <h3>Arduino Platform</h3>
            <p>Framework phát triển</p>
          </div>
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">build</span>
            </div>
            <h3>PlatformIO IDE</h3>
            <p>Môi trường phát triển</p>
          </div>
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">wifi</span>
            </div>
            <h3>WiFi & OTA</h3>
            <p>Kết nối không dây và cập nhật từ xa</p>
          </div>
          <div className="tech-item glass">
            <div className="tech-icon">
              <span className="material-icons">settings</span>
            </div>
            <h3>FreeRTOS</h3>
            <p>Hệ điều hành thời gian thực</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TechStack;
